<template>
  <div class="list contents">
    <template v-for="(item, index) in otherProductsAdvantages">
      <div class="list-item">
        <div class="list-item-contents">
          <img class="contents-img" :src="item.titleImg" />
          <p class="title">
            {{ item.title }}
          </p>
          <ul class="item-list">
            <li v-for="(info, indexs) in item.infoList">
              <i class="icon iconfont icon-yuandianzhong"></i>{{ info }}
            </li>
            <!-- <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li> -->
          </ul>
        </div>
      </div>
      <!-- <div class="list-item">
      <div class="list-item-contents">
        <img :src="sdfsdf" />
        <p>
          真空吸盘
        </p>
        <ul>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
        </ul>
      </div>
    </div>
    <div class="list-item">
      <div class="list-item-contents">
        <img :src="sdfsdf" />
        <p>
          真空吸盘
        </p>
        <ul>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
          <li>
            卓越的密封性能，减少能源消耗
          </li>
        </ul>
      </div>
    </div> -->
    </template>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    otherProductsAdvantages: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<!--声明语言，并且添加scoped-->
<style scoped>
.list .list-item {
  width: 375px;
  height: 416px;
  background-color: #fff;
}
.list .list-item .list-item-contents {
  width: 330px;
  margin: 0 auto;
}
.list-item-contents .contents-img {
  width: 100%;
  margin-top: 10px;
}
.list-item-contents .title {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  border-bottom: 1px solid rgba(102, 102, 102, 0.6);
  padding-bottom: 15px;
}

.list-item-contents .title .item-list {
  margin-top: 30px;
}
.title .item-list li {
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.06em;
  color: #333333;
}
.icon {
  color: #fbb113;
  font-size: 12px;
  margin-right: 5px;
}
.list {
  display: flex;
  justify-content: space-between;
  padding-bottom: 80px;
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/AdvantagesList.vue